import { useQuery } from '@tanstack/react-query'
import { supabase, supabaseReady } from '@/lib/supabase'
import type { AthleteRow } from './useAthletes'

/** Reads a single athlete by id (coach session required by RLS for others). */
export function useAthlete(id: string, enabled: boolean) {
  return useQuery({
    queryKey: ['athlete', id],
    enabled: enabled && supabaseReady && Boolean(id),
    queryFn: async (): Promise<AthleteRow | null> => {
      const { data, error } = await supabase
        .from('athletes')
        .select('id,name,current_week,program_template,vald_profile_id,email')
        .eq('id', id)
        .maybeSingle()
      if (error) throw error
      return (data as AthleteRow) ?? null
    },
  })
}
